'use client';

import { c as _c } from "react/compiler-runtime";
import '../uiPrimitives/base/layersStyle.css';
import '../uiPrimitives/base/base.css';
import { translateInline } from '@/globals/translate/translateInline';
import { siteTitle } from '@/globals/translate/siteMetaTranslations';
import { languageCode } from '@/globals/config/localization.config';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { rijksFont } from '@/uiPrimitives/font/fontFace';
import { headerAndPageGrid, rootGrid } from '@/uiPrimitives/layout/pageGrid/rootGrid.css';
import { focusMain } from '@/uiPrimitives/base/focus.css';
import { pageGrid } from '@/uiPrimitives/layout/pageGrid/pageGrid';
import { position } from '@/uiPrimitives/layout/position';
import { zIndex } from '@/uiPrimitives/layout/zIndex.css';
import { box } from '@/uiPrimitives/layout/box';
import { pageHeaderGrid, pageHeaderLogoSlot, pageHeaderRijksSlot } from '@/sections/pageHeader/PageHeader.css';
import { overflowClip } from '@/uiPrimitives/utility/overflow.css';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { IconRijkslogo } from '@/uiIcons/IconRijkslogo';
import { SiteLogo } from '@/sections/pageHeader/SiteLogo';
import { siteLogo } from '@/sections/pageHeader/SiteLogo.css';
import { textBlock, textStyle } from '@/uiPrimitives/typography/text';
import { footerContainer } from '@/sections/pageFooter/PageFooter.css';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { H1TextBlock } from '@/uiComposites/typography/headings';
import { icon } from '@/uiPrimitives/media/icon';
import { warningIcon } from '@/uiIcons/warningIcon.css';
import { stack } from '@/uiPrimitives/layout/stack';

// export of Metadata does not work in global error pages

export default function GlobalError() {
  const $ = _c(19);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classes(rijksFont.className);
    t1 = <title>{`${translateInline({
        en: "Website unavailable",
        nl: "Website niet beschikbaar"
      })} | ${siteTitle}`}</title>;
    t2 = <meta name="viewport" content="width=device-width, initial-scale=1" />;
    t3 = <meta name="robots" content="noindex,nofollow" />;
    t4 = <meta charSet="utf-8" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <head>{t1}{t2}{t3}{t4}<meta name="description" content={`${translateInline({
        en: "The website is currently unavailable",
        nl: "De website is momenteel niet beschikbaar"
      })}`} /></head>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = classes(pageGrid({}), position({
      position: "relative"
    }), zIndex({
      zIndex: "brandBar"
    }), box({
      backgroundColor: "negative"
    }));
    t7 = classes(pageHeaderGrid);
    t8 = classes(pageHeaderRijksSlot);
    t9 = classes(overflowClip, occupy({
      blockSize: {
        max640px: "8 | betweenCards"
      },
      alignItems: "end"
    }));
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  let t11;
  let t12;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className={t6}><div className={t7}><div className={t8}><div className={t9}><IconRijkslogo aria-label={translateInline({
              en: "Logo Dutch central government",
              nl: "Logo Rijksoverheid"
            })} className={box({
              inlineSize: {
                all: "7 | betweenH3Sections",
                max640px: "6 | betweenH4Sections"
              },
              blockSize: "auto"
            })} /></div></div><div className={classes(pageHeaderLogoSlot)}><SiteLogo className={siteLogo} /></div></div></div>;
    t11 = <div className={classes(pageGrid({}), box({
      blockSize: "8 | betweenCards",
      backgroundColor: "positiveBlue"
    }))} />;
    t12 = classes(pageGrid({
      alignItems: "start",
      columnCount: "8-of-12"
    }), position({
      position: "relative"
    }), box({
      paddingBlock: {
        all: "8 | betweenCards"
      }
    }), focusMain);
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
  } else {
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
  }
  let t13;
  let t14;
  let t15;
  let t16;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = classes(stack({
      rowGap: "8 | betweenCards"
    }));
    t14 = classes(shelf({
      columnGap: "3 | h1"
    }));
    t15 = <i className={classes(icon({
      icon: warningIcon,
      fill: "positiveBlue",
      size: "9 | asideBlockMargin"
    }))} />;
    t16 = classes(stack({
      rowGap: "3 | h1"
    }));
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
  } else {
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <H1TextBlock>{translateInline({
        en: "Oops, something went wrong.",
        nl: "Oeps... Er is iets misgegaan,"
      })}</H1TextBlock>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <html lang={languageCode} className={t0}>{t5}<body><div className={rootGrid}><div className={headerAndPageGrid}>{t10}{t11}<main className={t12} tabIndex={-1}><div className={t13}><div className={t14}>{t15}<div className={t16}>{t17}<H1TextBlock>{translateInline({
                        en: "But not because of something you did.",
                        nl: "maar het ligt niet aan u"
                      })}</H1TextBlock></div></div><div className={classes(stack({
                  rowGap: "6 | betweenH4Sections"
                }))}><p className={classes(textBlock({}))}>{translateInline({
                      en: "Our website cannot be loaded. We are working hard to fix this.",
                      nl: "Onze site kan niet geladen worden. Wij zijn druk bezig om dit te herstellen."
                    })}</p><p className={classes(textBlock({
                    fontWeight: "bold",
                    capSize: "1 | h3"
                  }))}>{translateInline({
                      en: "Please try again later.",
                      nl: "Probeer het later nog eens."
                    })}</p></div></div></main></div><footer className={classes(box({
            backgroundColor: "positiveProjectBrand",
            paddingBlock: "7 | betweenH3Sections"
          }), pageGrid({}), textStyle({
            fontWeight: "bold"
          }), footerContainer)} /></div></body></html>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  return t18;
}